__webpack_require__.p = "/bearcolor/";